import { flatMap, uniqBy } from "lodash";
import { Item } from "../models";
import { Entity } from "../models/entity.model";

export const entityToItem = (entity: Entity): Item => ({
    id: entity.id as string,
    label: entity.name,
});

export const itemToEntity = (item: Item): Entity => ({
    id: item.id as string,
    name: item.label,
});

export const entityToString = (data?: Entity[], join?: string) =>
    flatMap(uniqBy(data, "id"), "name").join(join ?? ", ");

/* this function searches deep in a collection for given argument-function and calls a replace function if argument is truthy */
export const findDeepAndReplace = (
    collection: any,
    find: (item: any) => boolean = (item) => !!item,
    replace: (item: any) => any = (item) => item,
    itemsProp: string = "items"
) =>
    collection.map((item: any) => {
        const mappedItem = Array.isArray(item[itemsProp])
            ? {
                  ...item,
                  [itemsProp]: findDeepAndReplace(
                      item[itemsProp],
                      find,
                      replace,
                      itemsProp
                  ),
              }
            : item;
        return find({
            ...mappedItem,
        })
            ? replace({ ...mappedItem })
            : mappedItem;
    });
